
export default class AbstractAxiosMock {
	constructor() {
		this.delayTime = 100
	}
	async request(method, url, ...args) {
		let path = url
		let fncPath = method.toUpperCase() + " " + path
		
		let fnc = null
		if (fncPath in this) {
			fnc = fncPath
		} else if (path in this) {
			fnc = path
		} else {
			Object.keys(this)
				.forEach(v => {
					if (fncPath.indexOf(v) == 0) {
						fnc = v
					}
				})
		}
	
		if (fnc) {
			await new Promise(r => setTimeout(r, 300))
			return this.delayMock(this[fnc](method, url, ...args))
				.then((res) => {
					console.debug("mock:", fnc, args, res)
					return Promise.resolve(res)
				})
				.catch((res) => {
					console.debug("mock:", fnc, args, res, "failed")
					return Promise.reject(res)
				})
		}
	
		return Promise.reject('mock not found: ' + fncPath)
	}

	delayMock(request) {
		if (this.delayTime <= 0) {
			return request
		}

		//if we want an delay, we make one
		return Promise.all([
			request,
			new Promise(resolve => setTimeout(resolve, this.delayTime)),
		])
		.then(
			([v]) => Promise.resolve(v),
			(v) => Promise.reject(v)
		)
	}

	fakeRequest(data, statusCode = 200, timeout = 0) {
		return new Promise((resolve, reject) => {
			var success = 200 <= statusCode && statusCode < 300
			var res = success
				? {
					data,
					statusCode
				}
				: {
					message: data.message || '',
					statusCode,
					response: {
						data
					}
				}
			setTimeout(success ? resolve : reject, timeout, res)
		})
	}

}